import { makeStyles } from "@material-ui/core";
import UtilService from "../../../../../../../helper/service";
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  xAxis5: {
    position: 'relative',
    '& > .line': {
      width: '2px',
      height: '100%',
      backgroundColor: '#212D40',
      opacity: 0.05,
    },
    '& > .label': {
      fontSize: 8.5,
      fontFamily: 'roboto-medium',
      color: '#8192A2',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(calc(-50% - 3px))',
      display: 'none',
    },
    '&:nth-of-type(1), &:nth-of-type(5n+1)': {
      '& > .label': {
        display: 'block',
      },
      '& > .line': {
        opacity: 0.1,
      },
    }
  },
  xAxis10: {
    position: 'relative',
    '& > .line': {
      width: '2px',
      height: '100%',
      backgroundColor: '#212D40',
      opacity: 0.05,
    },
    '& > .label': {
      fontSize: 8.5,
      fontFamily: 'roboto-medium',
      color: '#8192A2',
      position: 'absolute',
      left: '50%',
      transform: 'translateX(calc(-50% - 3px))',
      display: 'none',
    },
    '&:nth-of-type(1), &:nth-of-type(10n+1)': {
      '& > .label': {
        display: 'block',
      },
      '& > .line': {
        opacity: 0.1,
      },
    }
  },
  linePanel: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    height: 'calc(200% - 40px)',
    overflow: 'hidden',
    scrollbarWidth: 'none',
  },
}));

function BackgroundLines(props: any) {

  const classes = useStyles();
  const { getMaxWidth, graphType, allParticipants, live } = props;
  const width = getMaxWidth ? getMaxWidth : 1500;
  const { analyseStart, cliped, stimulus, currentSession, settings } = useSelector((state: any) => state.analysis);
  const { graphZoom } = settings;
  const { session_type } = currentSession;
  const start = (cliped && analyseStart) ? (cliped.start_clip - analyseStart) / Math.pow(graphZoom, 2) : 0;
  const graphMinimized = ((stimulus && stimulus.stimulus_video_length < 120 && session_type === 'ASYNC') || (cliped && (cliped.end_clip - cliped.start_clip) < 150));
  const unit = graphMinimized ? (15 / Math.pow(graphZoom, 2)) : 15;

  return (
    <div
      className={classes.linePanel}
      style={{
        width,
        marginTop: (graphType && graphType === 'LIVE') ? 30 : (allParticipants ? 15 : -25),
        height: allParticipants ? (live ? 230 : 300) : '200% - 40px)'
      }}
    >
      {width && Array(Math.ceil(width / unit)).fill('').map((_, index) => (
        <div
          data-id={index}
          key={index}
          className={graphMinimized ? classes.xAxis5 : classes.xAxis10}
          style={{ minWidth: `calc(100% / ${width / unit})`, }}
        >
          <div className='label'>
            {UtilService.getTimeLabel(index / 15 * unit, graphZoom, (cliped && stimulus && session_type === 'ASYNC') ? cliped.start_clip / Math.pow(graphZoom, 2) : start)}
          </div>
          <div className='line' />
        </div>
      ))}
    </div>
  );
}

export default BackgroundLines;